import appConstants from '../appConstants'

let mapGetters = Vuex.mapGetters,
    mapActions = Vuex.mapActions;


export default {
    template: '#book-dropDown-component',
    delimiters: ['${', '}'],
    data() {
        return {
            selectInStudioStep: false,
            region: null,
            location: null,
            locations: [],
            regions: [],
            filteredLocations: [],
            isLocationSelectDisabled: true,
            isButtonDisabled: true
        }
    },
    computed: {
        ...mapGetters([
            'getRegions',
            'getLocations'
        ]),
        regionsToSelect() {
            return this.regions.length ? this.regions.map((region) => {
                return region.name;
            }) : [];
        },
        locationsToSelect() {
            return this.filteredLocations.length ? this.filteredLocations.map((location) => {
                return location.name;
            }) : [];
        }
    },
    methods: {
        ...mapActions([
            'downloadData'
        ]),
        chooseLocation(selected) {
            if (selected) {
                this.isButtonDisabled = false;
            }
            this.location = selected;
        },
        chooseRegion(selected) {
            if (selected) {
                this.isLocationSelectDisabled = false;
            }
            this.filteredLocations = this.locations.filter((location) => location.region.name === selected)
            this.region = selected;
        },
        goToStudioStep() {
            this.downloadData(appConstants.DATA_REGIONS)
                .then(() => {
                    return this.downloadData(appConstants.DATA_LOCATIONS)
                })
                .then(() => {
                    this.regions = [...this.getRegions];
                    this.locations = [...this.getLocations];
                });
            this.selectInStudioStep = !this.selectInStudioStep;
        },
        closeDropDown() {
            this.selectInStudioStep = false;
            this.isButtonDisabled = true;
            this.isLocationSelectDisabled = true;
            this.$refs.bookDropDownWrap.classList.remove("opened");
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/bookDropDownComponent.js